<template>
  <!-- 主账号的弹出设置菜单 -->
  <div>
    <div class="menu_view_wraper">
      <div class="menu_ele1" @click="configMainManageBtnHandle">
        <img src="../../../../assets/img/controlpublic/guanli_shezhi.png" alt />
        <span>设置管理</span>
      </div>
      <!-- 只有区域和常用页面才需要界面管理 -->
      <div
        v-if="judgeActivePage() === '常用' || judgeActivePage() === '区域'"
        class="menu_ele1"
        @click="jiemianBtnHandle()"
      >
        <img
          src="../../../../assets/img/controlpublic/guanli_jiemian.png"
          alt
        />
        <span>界面管理</span>
      </div>

      <!-- 只有主账号才显示分享管理 -->
      <div
        v-if="userType === '0'"
        class="menu_ele1"
        @click="fenxiangBtnHandle()"
      >
        <img
          src="../../../../assets/img/controlpublic/guanli_fenxiang.png"
          alt
        />
        <span>分享管理</span>
      </div>

      <div class="menu_ele1" @click="beijingBtnHandle()">
        <img
          src="../../../../assets/img/controlpublic/guanli_beijing.png"
          alt
        />
        <span>背景更换</span>
      </div>
    </div>
  </div>
</template>

<script>
import { judgeActivePage, publicFadeInOut } from 'common/tool'

export default {
  data() {
    return {
      userType: sessionStorage.getItem('userType'), ////获取子账号和主账号的状态  0主账号1子账号
      DregionMenuState: this.regionMenuState
    }
  },
  props: {
    regionMenuState: Object ///控制淡入淡出
  },

  methods: {
    configMainManageBtnHandle() {
      ///下面是为了从设置页面返回到进入页面所以需要存一下路径
      console.log(this.$route.path)
      this.$store.dispatch('asyUpdataConfigReturnPath', this.$route.path) ///异步提交
      // 这里为了使设置页面返回到进入前的页面所以需要push
      this.$router.push('/ConfigMainPage')
    },
    jiemianBtnHandle() {
      console.log('界面管理被点击了')
      if (judgeActivePage() === '区域') {
        if (this.$store.state.publicinfo.regionShowPage.name === '全部区域') {
          this.$toast('全部区域暂不支持界面管理，请选择其他区域再试哦~', 3000)
          return
        }
      }

      this.$toast('长按拖动，可进行排序哦~', 3000)
      this.$store.dispatch('asyUpdataobjectMoveState', true) ///异步提交界面管理状态到仓库
      console.log(this.regionMenuState)
      publicFadeInOut(this.DregionMenuState, 400, 1) ///实现淡入淡出关闭
    },
    fenxiangBtnHandle() {
      console.log('分享管理被点击了')
      this.$router.push('/shareManage')

      // this.$toast('暂未开放~')
    },
    beijingBtnHandle() {
      console.log('背景管理被点击了')
      this.$router.push('/backgroundManage')

      // this.$toast('暂未开放~')
    },
    judgeActivePage() {
      return judgeActivePage()
    }
  }
}
</script>

<style>
.menu_view_wraper {
  color: #000;
  font-size: 18px;
  background-color: #ffffff;
  border-radius: 5px;
  padding: 5px;

  position: relative;
  width: 100%;
  height: 100%;
}

.menu_view_wraper::before {
  /* 消息尖角样式及定位 */
  content: '';
  width: 0px;
  height: 0px;
  border: 15px solid;
  border-color: transparent transparent #ffffff transparent;
  position: absolute;
  top: -28px;
  left: 95px;
}
.menu_ele1 {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;

  padding: 10px;

  cursor: pointer; /*移入时光标样式*/
}
.menu_ele1:hover {
  /* background-color: rgba(0, 0, 0, 0.4); */
  border-radius: 4px;
  box-shadow: 0 0 4px var(--primary-color);
}

.menu_ele1 img {
  width: 28px;
  height: 28px;
  margin-right: 6px;
  margin-left: -4px;
}
</style>
